import { render, staticRenderFns } from "./TestnetFaucet.vue?vue&type=template&id=2d88c5e2&scoped=true&"
import script from "./TestnetFaucet.vue?vue&type=script&lang=ts&"
export * from "./TestnetFaucet.vue?vue&type=script&lang=ts&"
import style0 from "./TestnetFaucet.vue?vue&type=style&index=0&id=2d88c5e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d88c5e2",
  null
  
)

export default component.exports